import { sendGoogleEvent, generateInViewportEvent } from '@html/_common/utils';

import AOCarousel from '@atomic/organisms/_common/carousel/carousel';

/**
 * Initiates the adventure type section, including carousel initialization and event handling.
 *
 * @param {Object} common - The common object containing shared functionalities.
 * @param {string} eventCategory - The category for the Google Analytics events.
 */
export default function initiateAdventureType(eventCategory) {
  const isPrivateOfTheShelf = document.querySelector('main').dataset.private === '1';
  const adventureTypeCarousel = new AOCarousel('.js-ao-tour-adventure-type__carousel');
  adventureTypeCarousel.initiate();

  const groupCard = '#group-adventure-type-card';
  const privateCard = '#private-adventure-type-card';
  const availabilityButton = '.js-ao-tour-adventure-type__check-availability';
  const privateTabButtonSelector = '.js-ao-tour-private-request_availability-private';
  const groupTabButtonSelector = '.js-ao-tour-private-request_availability-group';

  $(`${privateCard} ${availabilityButton}`).on('click', () => {
    const privateButton = document.querySelector(privateTabButtonSelector);
    privateButton.dataset.scrollTo = 'check';

    $(privateTabButtonSelector).trigger('click');
    sendGoogleEvent(
      eventCategory,
      'Personalized Panel Click',
      'Check Availability - Private TDP',
    );

    setTimeout(() => {
      privateButton.dataset.scrollTo = 'departures';
    }, 2000);
  });

  $(`${groupCard} ${availabilityButton}`).on('click', () => {
    const groupButton = document.querySelector(groupTabButtonSelector);
    groupButton.dataset.scrollTo = 'check';

    $(groupTabButtonSelector).trigger('click');
    sendGoogleEvent(
      eventCategory,
      'Personalized Panel Click',
      'Check Availability - Group TDP',
    );

    setTimeout(() => {
      groupButton.dataset.scrollTo = 'departures';
    }, 2000);
  });

  const viewportListener = generateInViewportEvent({
    category: eventCategory,
    action: 'Scroll',
    label: `Personalized Panel - ${isPrivateOfTheShelf ? 'Private' : 'Group'} TDP`,
  });
  const adventureTypeSection = document.getElementById('tour-adventure-type');
  if (adventureTypeSection) {
    viewportListener.observe(adventureTypeSection);
  }
}
